import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'embed-contact',
    path: '/embed/contact',
    component: () => LazyLoadView(import(/* webpackChunkName: "embed-contact" */ '@/views/Embed/Contact.vue')),
    meta: {
      skipAuth: true,
      navigation: false,
      footer: false,
    },
  },
]
